






































import {Component, Prop, Vue} from 'vue-property-decorator';
import {PModuleMAC, PModuleWithMeasurements} from '@/views/system/modules/interfaces';
import {
  actionComponentsByTypeMap,
  pmoduleActionsByTypeMap,
  pmoduleStoresByTypeMap,
} from '@/views/system/modules/configurate';
import EditDialog from '@/components/EditDialog.vue';
import {connectionGetActiveDevices} from '@/api/configApi';
import dtcpServerStoreModule from '@/store/modules/entities/pmodules/dtcp/dtcpServerStoreModule';
import pmoduleModule from '@/store/modules/entities/pmodules/pmoduleModule';
import {PModuleType} from '@/enums/configs';
import Card from '@c/Card.vue';
import {httpClient} from '@/api/baseApi';

@Component({
  components: {
    EditDialog,
    Card,
  },
})
export default class MainTabDeveloperInfo extends Vue {
  @Prop()
  pmodule!: PModuleWithMeasurements;

  // список mac адресов для выбора
  macs: PModuleMAC[] = [];

  socket!: WebSocket | null;

  // Получить хранилище
  get apiStore(): any {
    return (pmoduleStoresByTypeMap.get(this.pmodule.type) as any) as any;
  }

  error = false;
  loading = true;

  components: any[] = [];

  reloadedDevices: string[] = [];

  get isDtcpServer() {
    return this.pmodule.type == PModuleType.DtcpServerModule;
  }

  // TODO: Вынести этот код в mixin
  async mounted() {
    try {
      const actionTypes = pmoduleActionsByTypeMap.get(this.pmodule.type);
      if (!actionTypes) return;
      this.components = actionTypes.map(type => actionComponentsByTypeMap.get(type));
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  async onClick() {
    // получаем все модули и находим dtcp-сервер
    await pmoduleModule.fetchAll();
    const dtcpServers = pmoduleModule.all.filter(x => x.type === PModuleType.DtcpServerModule);
    if (dtcpServers.length) {
      // если есть dtcp-сервера, берем один из них
      const dtcpServer = dtcpServers[0];
      const getDevicesAction = async (servId: number | undefined) => {
        if (servId) {
          await dtcpServerStoreModule.processGetActiveDevicesAction({id: servId});
        }
        return;
      };

      if (dtcpServer.guid) {
        //подключаемся к веб сокету
        if (!this.socket) {
          this.socket = connectionGetActiveDevices(dtcpServer.guid);
        } else {
          await getDevicesAction(dtcpServer.id);
        }
        this.socket.onopen = () => {
          //отправляем action
          getDevicesAction(dtcpServer.id);
        };
        this.socket.onmessage = (e: any) => this.subscribeConectionWS(e);
      }
    }
    this.reloadedDevices = [];
  }

  async reload(item: any) {
    await httpClient.put(`dtcp-server-modules/${this.pmodule.id}/actions/device_reboot/`, null, {
      params: {
        mac: item.device,
      },
    });
    this.reloadedDevices.push(item.device);
  }

  closeSocket() {
    if (this.socket) {
      this.socket.close();
    }
  }

  subscribeConectionWS(e: {data: string}) {
    this.macs = [];
    const strParse = JSON.parse(e.data);
    const macs = strParse.data.devices.map((x: any) => ({
      device: x.mac,
      description: `${x.mac} - ${x.type} (${x.fw_ver})`,
    }));
    this.macs = macs;
  }

  beforeDestroy() {
    this.closeSocket();
  }
}
